import React, { useState } from 'react'
import { useToggle } from '../utils/hooks'
import PropTypes from 'prop-types'
import ContentModal from '../ContentModal'
import VideoThumbnail from '../VideoThumbnail'
import { extractYoutubeID } from '../utils/helpers'

const LandingVideos = ({ block }) => {
  const { videos, className } = block

  const [video, setVideo] = useState({})
  const [isVideoModalOpen, toggleVideoModal] = useToggle()

  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 py-5 p-lg-5 d-flex flex-column flex-lg-row align-items-center'>
        {videos.map((d, i) => {
          return (
            <div className='col px-5 px-md-0 pe-lg-3 pb-4 pb-lg-4 pe-5 pt-3' key={i} data-cy='toggle-video' onClick={() => {
              setVideo({ ...d })
              toggleVideoModal()
            }}>
              <VideoThumbnail uri={d.link} name={d.title || ''} time={d.time || ''} extractYoutubeID={extractYoutubeID} />
            </div>
          )
        })}
      </div>
      <ContentModal
        isOpen={isVideoModalOpen}
        toggle={toggleVideoModal}
        title={video.title}
        noCancel
        className='p-0'>
        <div className='mb-4'>
          <iframe width='100%' height='450' style={{ margin: '0 auto', display: 'block' }} src={`https://www.youtube.com/embed/${extractYoutubeID(video.link)}`} data-cy='landing-video' frameBorder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowFullScreen />
        </div>
      </ContentModal>
    </div>
  )
}

LandingVideos.propTypes = {
  block: PropTypes.object
}

export default LandingVideos
